import Vue from 'vue'
import App from './App.vue'
import VS2 from 'vue-script2'
import router from './router'
import vuetify from './plugins/vuetify'
import VueAgile from 'vue-agile'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSocialSharing from 'vue-social-sharing'

library.add(faAngleLeft)
library.add(faAngleRight)

Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.config.productionTip = false;

Vue.use(VueSocialSharing, {
  networks: {
    fakeblock: 'https://fakeblock.com/share?url=@url&title=@title'
  }
})

new Vue({
  vuetify,
  router,
  VS2,
  VueAgile,
  BootstrapVue,
  IconsPlugin,
  render: h => h(App),
}).$mount('#app')

